module.exports = __webpack_public_path__ + "img/insta_logo.4f5f3876.png";